/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contentreportsloaderror3Inputs */

const en_contentreportsloaderror3 = /** @type {(inputs: Contentreportsloaderror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to load reports`)
};

const de_contentreportsloaderror3 = /** @type {(inputs: Contentreportsloaderror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meldungen konnten nicht geladen werden`)
};

/**
* | output |
* | --- |
* | "Failed to load reports" |
*
* @param {Contentreportsloaderror3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const contentreportsloaderror3 = /** @type {((inputs?: Contentreportsloaderror3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contentreportsloaderror3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contentreportsloaderror3(inputs)
	return de_contentreportsloaderror3(inputs)
});
export { contentreportsloaderror3 as "contentReportsLoadError" }